<script setup lang="ts">
// 사용자 세션 복원을 위한 userStore 가져오기
const userStore = useUserStore()

// 레이아웃이 마운트될 때 사용자 세션 복원
onMounted(async () => {
  try {
    await userStore.getCurrentUser()
  }
  catch (error) {
    console.error('❌ Home 레이아웃: 사용자 세션 복원 실패:', error)
  }
})
</script>

<template>
  <v-app>
    <ClientDrawerRight />
    <AppBar />
    <NavigationDrawer />
    <v-main>
      <slot />
    </v-main>
    <Footer />

    <!-- 전역 다이얼로그 -->
    <GlobalDialog />
  </v-app>
</template>

<style scoped>
/* AppBar 고정에 따른 전역 스타일 조정 */
:deep(.v-main) {
  padding-top: 85px !important;
  padding-left: 0 !important;
  @media (min-width: 960px) {
    padding-left: 256px !important;
  }
  @media (max-width: 959px) {
    padding-top: 80px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
:deep(.v-footer) {
  margin-left: 256px !important;
  @media (max-width: 959px) {
    margin-left: 0 !important;
  }
}
</style>
